export function SignupSuccess({ email }: { email: string }) {
  return (
    <section className="waitlist" aria-label="Class signup">
      <div className="signup-success">
        <span>✦</span>
        <h2>You’re signed up for classes.</h2>
        <p>
          We’ll send the next class update to <strong>{email}</strong>.
        </p>
      </div>
    </section>
  )
}
